// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"lz-z","breadcrumbForward":"mz-z","breadcrumbBack":"nz-z","selected":"oz-z"};